import ApiService from "@/services/apiservice";
import { LOGIN, REGISTER,REQUEST_RESET_PASSWORD,LIST_ROLES,ADD_ROLE,
  EDIT_ROLE,LIST_ADMIN_USERS,RESET_PASSWORD, ACTIVATE_USER,LIST_MODULES,
  LIST_USERS,GET_ROLE,ADD_USER,EDIT_USER,GET_SELECT_ROLES,GET_USER,
  GET_ADMIN_USER,GET_DASHBOARD,CHANGE_PASSWORD,DELETE_ADMIN,
  GET_LOGS,DELETE_ROLE,UPDATE_PROFILE,GET_PROFILE,LIST_CONFIGURATIONS,
  UPDATE_CONFIGURATIONS,LIST_FUEL_CAPACITY,UPDATE_FUEL_CAPACITY,
  CREATE_FUEL_CAPACITY ,GET_FUEL_CAPACITY,GET_VEHICLE_LIST } from "./actions.type";
import { SET_AUTH, SET_ERROR,SET_PROFILE_IMAGE } from "./mutations.type";

const state = {
  errors: null,
  user: {},
  access_token: ""
};

const getters = {};

const actions = {
  async [LOGIN](context, payload) {
    try {
      let {data} = await  ApiService.post("login", payload);
      context.commit(SET_AUTH, data);
      return data;

    } catch (error) {
      context.commit(SET_ERROR, error);
      return {success:false, message:error.toString()}
    }
  },
  async [REGISTER](context, payload) {
    try {
      return await ApiService.post("user/register", payload);
    } catch (error) {
      context.commit(SET_ERROR, response);
      return {success:false, message:error.toString()}
    }
    
  },
    async [REQUEST_RESET_PASSWORD](context, payload) {
      try {
        let {data} = await  ApiService.post("forgotpassword/create", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [RESET_PASSWORD](context, payload) {
      try {
        let {data} = await  ApiService.post("forgotpassword/reset", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [ACTIVATE_USER](context, payload) {
      try {
        let {data} = await  ApiService.post("user/activate", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [LIST_USERS](context, payload) {
      try {
        let {data} = await  ApiService.get("users", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [LIST_ADMIN_USERS](context, payload) {
      try {
        let {data} = await  ApiService.get("admin/users", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [LIST_ROLES](context, payload) {
      try {
        let {data} = await  ApiService.get("roles", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },

    async [ADD_ROLE](context, payload) {
      try {
        let {data} = await  ApiService.post("roles/create", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [EDIT_ROLE](context, payload) {
      try {
        let {data} = await  ApiService.post("roles/edit", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [LIST_MODULES](context, payload) {
      try {
        let {data} = await  ApiService.get("modules", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_ROLE](context, payload) {
      try {
        let {data} = await  ApiService.get("roles/get", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_SELECT_ROLES](context, payload) {
      try {
        let {data} = await  ApiService.get("roles/all", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_LOGS](context, payload) {
      try {
        let {data} = await  ApiService.get("logs/list", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [ADD_USER](context, payload) {
      try {
        let {data} = await  ApiService.post("admin/add", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    
    async [EDIT_USER](context, payload) {
      try {
        let {data} = await  ApiService.post("admin/edit", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_ADMIN_USER](context, payload) {
      try {
        let {data} = await  ApiService.get("admin/get", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_USER](context, payload) {
      try {
        let {data} = await  ApiService.get("user/detail", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_DASHBOARD](context, payload) {
      try {
        let {data} = await  ApiService.get("dashboard", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [CHANGE_PASSWORD](context, payload) {
      try {
        let {data} = await  ApiService.post("reset", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [DELETE_ADMIN](context, payload) {
      try {
        let {data} = await  ApiService.post("delete/admin", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [DELETE_ROLE](context, payload) {
      try {
        let {data} = await  ApiService.post("roles/delete", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_PROFILE](context, payload) {
      try {
        let {data} = await  ApiService.get("me", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },async [UPDATE_PROFILE](context, payload) {
      try {
        let {data} = await  ApiService.fileUpload("me/update", payload);
        context.commit(SET_PROFILE_IMAGE, data);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [LIST_CONFIGURATIONS](context, payload) {
      try {
        let {data} = await  ApiService.get("configuration/get", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [UPDATE_CONFIGURATIONS](context, payload) {
      try {
        let {data} = await  ApiService.post("configuration/update", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [UPDATE_FUEL_CAPACITY](context, payload) {
      try {
        let {data} = await  ApiService.post("fuelcapacity/update", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [CREATE_FUEL_CAPACITY](context, payload) {
      try {
        let {data} = await  ApiService.post("fuelcapacity/create", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
     async [LIST_FUEL_CAPACITY](context, payload) {
      try {
        let {data} = await  ApiService.get("fuelcapacity/list", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_FUEL_CAPACITY](context, payload) {
      try {
        let {data} = await  ApiService.get("fuelcapacity/get", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
    async [GET_VEHICLE_LIST](context, payload) {
      try {
        let {data} = await  ApiService.get("vehicle/get", payload);
        return data;
  
      } catch (error) {
        context.commit(SET_ERROR, error);
        return {success:false, message:error.toString()}
      }
    },
};

const mutations = {
  [SET_ERROR](state, error) {
    state.errors = error;
  },
  [SET_AUTH](state, response) {
    if (response.status == true) {
      localStorage.removeItem("userToken");
      localStorage.removeItem("user");
      const token = "Bearer" + " " + response.success.token;
      const user = response.success.user;
      localStorage.setItem("userToken", token);
      localStorage.setItem("user", JSON.stringify(user));
      ApiService.setHeader();

      state.access_token = token;
    }
  },
  [SET_PROFILE_IMAGE](state, response) {
    if (response.status == true) {
      localStorage.removeItem("user");
      const user = response.user;
      localStorage.setItem("user", JSON.stringify(user));
      window.dispatchEvent(new CustomEvent('user-localstorage-changed', {
        detail: {
          storage: localStorage.getItem("user")
        }
      }));
      ApiService.setHeader();
    }
  }

};

export default {
  state,
  actions,
  mutations,
  getters
};



// WEBPACK FOOTER //
// ./src/store/auth.module.js